import Vue from "vue";
import Vuex from "vuex";

// 挂载Vuex
Vue.use(Vuex);

// 创建VueX对象
const store = new Vuex.Store({
  state: {
    // 存放的键值对就是所要管理的状态
    language: "cn"
  },
  getters: {
    language: state => state.language
  },
  mutations: {
    changeLanguage (state, type) {
      state.language = type;
    }
  }
});

export default store;